<template lang="pug">
.container-restricao
    .card-restricao(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido !== "undefined" && restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in restricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricao)'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                |
                | {{ restricao?.nome || restricao?.properties?.nome || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigo') }}:
                |
                | {{ restricao?.codigo || restricao?.properties?.codigo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.alerta') }}:
                |
                | {{ restricao?.alerta || restricao?.properties?.alerta || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.data_criac') }}:
                |
                | {{ restricao?.data_criac || restricao?.properties?.data_criac || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigo_pro') }}:
                |
                | {{ restricao?.codigo_pro || restricao?.properties?.codigo_pro || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numero_pro') }}:
                |
                | {{ restricao?.numero_pro || restricao?.properties?.numero_pro || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.codigo_inf') }}:
                |
                | {{ restricao?.codigo_inf || restricao?.properties?.codigo_inf || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome_razao') }}:
                |
                | {{ restricao?.nome_razao || restricao?.properties?.nome_razao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpf_cnpj') }}:
                |
                | {{ restricao?.cpf_cnpj || restricao?.properties?.cpf_cnpj || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio_') }}:
                |
                | {{ restricao?.municipio_ || restricao?.properties?.municipio_ || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.infracao') }}:
                |
                | {{ restricao?.infracao || restricao?.properties?.infracao || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.categoria') }}:
                |
                | {{ restricao?.categoria || restricao?.properties?.categoria || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.sub_catego') }}:
                |
                | {{ restricao?.sub_catego || restricao?.properties?.sub_catego || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.area') }}:
                |
                | {{ restricao?.area || restricao?.properties?.area || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.origem') }}:
                |
                | {{ restricao?.origem || restricao?.properties?.origem || '-' }}

                Criticidade(
                    v-if='restricao?.nivelAlerta || restricao?.properties?.nivelAlerta',
                    :restricao='restricao?.properties ? restricao?.properties : restricao'
                )

</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

export default {
    name: 'auto-infracao-go-ponto',
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        Criticidade
    },
    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (isNaN(number)) {
                return '-';
            }
            let floatNumber = parseFloat(number);
            return floatNumber.toLocaleString('pt-BR', {
                maximumFractionDigits: 2
            });
        },
        formatDate(date) {
            if (!date) return '-';
            return formatters.formatDate(date);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        formatCpfCnpj(cpfCnpj) {
            if (!cpfCnpj) return '-';
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>

<style lang="scss"></style>
